var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMitten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.019 416H64.005C46.403 416 32.005 430.4 32.005 448V480C32.005 497.6 46.403 512 64.005 512H352.019C369.618 512 384.019 497.6 384.019 480V448C384.019 430.4 369.618 416 352.019 416ZM425.021 206.877C397.769 184.252 357.517 187.877 334.892 215.127L314.017 240.127L284.39 111.752C266.388 34.252 189.011 -14.246 111.632 3.752C34.255 21.627 -14.247 98.877 3.753 176.377L63.999 384H351.999L433.146 297.002C455.773 269.752 452.146 229.502 425.021 206.877Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitten);
export default __webpack_public_path__ + "static/media/mitten.c213cf5dbf7b739b69c5bb6e0fd8bbcd.svg";
export { ForwardRef as ReactComponent };